import React from 'react';
import { Floor, Apartment } from '../types/building';
import { ApartmentCell } from './ApartmentCell';
import { Trash2 } from 'lucide-react';
import { getFloorLabel } from '../utils/floorLabels';

interface FloorRowProps {
  floor: Floor;
  onApartmentClick: (apartment: Apartment) => void;
  onDeleteFloor: (floorId: string) => void;
  onDeleteApartment: (floorId: string, apartmentId: string) => void;
}

export const FloorRow: React.FC<FloorRowProps> = ({ 
  floor, 
  onApartmentClick, 
  onDeleteFloor,
  onDeleteApartment,
}) => {
  const floorLabel = getFloorLabel(floor);
  
  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-xl font-bold text-gray-800 break-words">
            {floorLabel}
          </h3>
          <button
            onClick={() => onDeleteFloor(floor.id)}
            className="p-1.5 text-red-600 hover:bg-red-50 rounded-full transition-colors shrink-0"
            title="Etage löschen"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
      
      {floor.apartments.length === 0 ? (
        <div className="text-center py-8 bg-gray-50 rounded-lg">
          <p className="text-gray-500">Keine Wohnungen vorhanden</p>
        </div>
      ) : floor.apartments.length === 2 ? (
        // Spezialfall für genau 2 Wohnungen: Grid mit 2 Spalten
        <div className="grid grid-cols-2 gap-4">
          {floor.apartments.map((apartment) => (
            <div key={apartment.id} className="col-span-1">
              <ApartmentCell
                apartment={apartment}
                onClick={onApartmentClick}
                onDelete={() => onDeleteApartment(floor.id, apartment.id)}
                isFullWidth={false}
              />
            </div>
          ))}
        </div>
      ) : (
        // Standard-Grid für 1 oder 3+ Wohnungen
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {floor.apartments.map((apartment) => {
            // Bestimme das Layout basierend auf der Anzahl der Wohnungen
            const totalApartments = floor.apartments.length;
            let colSpanClass = "";
            
            if (totalApartments === 1) {
              // Eine Wohnung nimmt die volle Breite ein
              colSpanClass = "col-span-1 sm:col-span-2 lg:col-span-3";
            }
            
            return (
              <div key={apartment.id} className={colSpanClass}>
                <ApartmentCell
                  apartment={apartment}
                  onClick={onApartmentClick}
                  onDelete={() => onDeleteApartment(floor.id, apartment.id)}
                  isFullWidth={totalApartments === 1}
                />
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};